import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from "react";
/** Context that provides loading state to child components */
const LoadingStateContext = createContext(null);
/**
 * Wrapper component that provides loading state context to its children.
 */
export function LoadingWrapper(t0) {
  const $ = _c(5);
  const {
    children,
    isLoading
  } = t0;
  let t1;
  if ($[0] !== isLoading) {
    t1 = {
      isLoading
    };
    $[0] = isLoading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <LoadingStateContext.Provider value={t1}>{children}</LoadingStateContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

/**
 * Hook to access the loading state context.
 * Returns `null` if used outside of the LoadingWrapper
 *
 * @returns The loading state context, or null if not within a wrapper
 */
export function useLoadingState() {
  return useContext(LoadingStateContext);
}